/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { HelpTip, Select } from 'sarsaparilla';

export default function PassType({ isLabelVisible = true, value, onChange, id }) {
    const options = [
        { value: '', label: 'None' },
        { value: 'Interagency Access Pass', label: 'Interagency Access Pass' },
        { value: 'Interagency Senior Pass', label: 'Interagency Senior Pass' },
    ];
    return (
        <Select
            id={id || 'pass-type'}
            isLabelVisible={isLabelVisible}
            label={
                <span>
                    Pass Type
                    <HelpTip
                        tipForDescriptor="pass types"
                        maxWidth={300}
                        content="The Interagency Senior and Access Pass are accepted. Although Golden Access and Golden Age Passports are no longer sold, these passes will continue to be honored according to the provisions of the pass."
                    />
                </span>
            }
            onChange={({ target: { value: v } }) => onChange(v)}
            options={options}
            value={value}
        />
    );
}

PassType.propTypes = {
    isLabelVisible: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func,
    id: PropTypes.string,
};
